<template>
  <v-app class="ficenca-app">
    <Toolbar></Toolbar>
    <v-main class="ficenca-main">
      <transition name="ficenca-view" mode="out-in">
        <router-view/>
      </transition>
    </v-main>
  </v-app>
</template>

<style scoped>


@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
*{
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  letter-spacing: 0;
}

</style>


<script>
import Toolbar from './components/Toolbar.vue';
import './styles/ficenca-ui.css';

export default {
  name: 'App',
  components: {
    Toolbar
  },
  data() {
    return {
      datos: {
        nombre: '',
        cedula: '',
        tlf: '',
        username: ''
      }
    };
  }
};
</script>

